import React, { useState } from "react";
import { Target, CheckCircle2 } from "lucide-react";

export const GoalCard = ({ d }) => {
  const g = d.goal;
  const pct = Math.min(100, Math.round((g.value / (g.target || 1)) * 100));
  const met = g.status === "met";
  return (
    <section className={`tc-card p-5 space-y-3 ${met ? "border-tc-bull/40" : ""}`} data-testid="family-goal-card">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="text-[11px] font-mono uppercase tracking-widest text-tc-xp flex items-center gap-1.5"><Target className="w-3.5 h-3.5" /> This week's goal</div>
        <div className="text-xs text-tc-muted" data-testid="family-goal-days-left">{d.days_left} day{d.days_left === 1 ? "" : "s"} left</div>
      </div>
      <div>
        <div className="font-heading text-2xl font-bold" data-testid="family-goal-label">{g.label}</div>
        <p className="text-sm text-tc-sub mt-1">{g.explain}</p>
      </div>
      <div>
        <div className="flex justify-between text-sm font-mono"><span data-testid="family-goal-progress">{g.value} / {g.target}</span><span>{pct}%</span></div>
        <div className="h-2 rounded-full bg-white/10 mt-1.5 overflow-hidden"><div className={`h-full ${met ? "bg-tc-bull" : "bg-tc-xp"}`} style={{ width: `${pct}%` }} /></div>
      </div>
      {met ? (
        <div className="text-sm font-semibold text-tc-bull flex items-center gap-1.5" data-testid="family-goal-met"><CheckCircle2 className="w-4 h-4" /> Goal met. {g.bonus_copy}</div>
      ) : <p className="text-xs text-tc-muted" data-testid="family-goal-bonus-copy">When the goal is met: {g.bonus_copy}</p>}
      <div className="flex flex-wrap gap-3 text-xs" data-testid="family-goal-contributions">
        {d.members.map((m) => <span key={m.id} className="text-tc-sub">{m.is_me ? "You" : m.first_name}: <span className="font-mono text-tc-txt">{m.contribution}</span></span>)}
      </div>
      {d.next_goal && <p className="text-xs text-tc-muted" data-testid="family-next-goal">Next week: {d.next_goal.label}</p>}
    </section>
  );
};

export const GoalPicker = ({ d, act }) => {
  const [type, setType] = useState("combined_xp");
  const [tier, setTier] = useState(300);
  const opt = d.menu.find((m) => m.type === type);
  const body = (week) => ({ type, tier: opt.tiers ? Number(tier) : null, week });
  return (
    <section className="tc-card p-4 flex flex-wrap items-center gap-2 text-sm" data-testid="family-goal-picker">
      <span className="text-[11px] font-mono uppercase tracking-widest text-tc-muted">{d.is_parent ? "Choose a goal" : "Suggest a goal"}</span>
      <select data-testid="family-goal-type" value={type} onChange={(e) => setType(e.target.value)} className="rounded-lg bg-tc-bg border border-white/10 px-2 py-1.5">
        {d.menu.map((m) => <option key={m.type} value={m.type}>{m.name}</option>)}
      </select>
      {opt?.tiers && (
        <select data-testid="family-goal-tier" value={tier} onChange={(e) => setTier(e.target.value)} className="rounded-lg bg-tc-bg border border-white/10 px-2 py-1.5">
          {opt.tiers.map((t) => <option key={t} value={t}>{t} XP</option>)}
        </select>
      )}
      {d.is_parent ? (
        <>
          <button data-testid="family-goal-set-current" disabled={d.goal.locked} onClick={() => act("/family-week/goal", body("current"), "This week's goal updated")}
            className="rounded-lg bg-tc-coach text-tc-bg font-semibold px-3 py-1.5 text-xs disabled:opacity-40">Set for this week</button>
          <button data-testid="family-goal-set-next" onClick={() => act("/family-week/goal", body("next"), "Next week's goal saved")}
            className="rounded-lg border border-white/15 px-3 py-1.5 text-xs">Set for next week</button>
          {d.goal.locked && <span className="text-xs text-tc-muted" data-testid="family-goal-locked">This week's goal is locked once the family makes progress.</span>}
        </>
      ) : (
        <button data-testid="family-goal-suggest" onClick={() => act("/family-week/suggest", body("current"), "Suggestion sent to your parent")}
          className="rounded-lg border border-white/15 px-3 py-1.5 text-xs">Suggest</button>
      )}
      <p className="w-full text-xs text-tc-muted">{opt?.explain}</p>
    </section>
  );
};
